function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.222 16H1.778A1.78 1.78 0 0 1 0 14.222V1.778C0 .798.797 0 1.778 0H8v1.778H1.778v12.444h12.444v-8H16v8c0 .98-.796 1.778-1.778 1.778"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.707 7.996c.11-.546.517-.67.908-.279l1.78 1.78c.392.392.267.798-.279.907l-2.022.405c-.546.11-.9-.246-.791-.79l.404-2.023zm9.883-4.961A1.777 1.777 0 1 0 12.077.52L7.125 5.473c-.39.39-.387 1.023.008 1.419L8.22 7.979a1.007 1.007 0 0 0 1.418.008l4.952-4.952z"
}));

var SvgWorkingDoc = function SvgWorkingDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorkingDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WorkingDoc.4998acd7.svg";
export { ForwardRef as ReactComponent };